module.exports = __webpack_public_path__ + "../css/bundle.font.min.css";